import styled from '@emotion/styled';

import { mqMax } from '@/lib/theme';

/** Holds a "Show more" / "Show all" button: full width on phones, its own width above. */
export const MoreAction = styled.div`
	${mqMax.md} {
		& > button {
			width: 100%;
		}
	}
`;
